module.exports = __webpack_public_path__ + "static/media/S1N1-2.4fd56776.svg";